module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('el-form', {
    ref: "form",
    staticClass: "login-container",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-position": "left",
      "label-width": "0px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Login")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "username"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "login"
    },
    model: {
      value: (_vm.form.username),
      callback: function($$v) {
        _vm.$set(_vm.form, "username", $$v)
      },
      expression: "form.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "password"
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.$set(_vm.form, "password", $$v)
      },
      expression: "form.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('button', {
    staticClass: "el-button el-button--primary",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "submit",
      "loading": _vm.loading
    }
  }, [_c('span', [_vm._v("Login")])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b280c0ae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Login.vue
// module id = 795
// module chunks = 0